export default __webpack_public_path__ + "static/containers-a9eed0f2378ca039b437966a35a8cefc.jpg";